import { create } from 'zustand'

const useLoadingStore = create((set) => ({
  isGenerating: false,
  isLoadingImages: false,
  isSavingVersion: false,
  generationProgress: 0,
  setIsGenerating: (value) => set({ isGenerating: value }),
  setIsLoadingImages: (value) => set({ isLoadingImages: value }),
  setIsSavingVersion: (value) => set({ isSavingVersion: value }),
  setGenerationProgress: (value) => set({ generationProgress: value }),
  reset: () => set({
    isGenerating: false,
    isLoadingImages: false,
    isSavingVersion: false,
    generationProgress: 0
  })
}))

export default useLoadingStore 